module.exports = __webpack_public_path__ + "media/images/new_culture/segment-ranges-5b582cdfd5508c729a43843d10a80b06.png";